import classNames from 'classnames';
import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import type { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';

interface ListGroupItemProps {
  children: ReactNode;
  className?: string;
  e2e?: string;
  labelKey: IntlKey;
  defaultLabelMessage?: string;
}

export const ListGroupItem: FC<ListGroupItemProps> = ({
  children,
  className,
  e2e,
  labelKey,
  defaultLabelMessage = labelKey,
}) => {
  const { formatMessage } = useIntl();
  return (
    <li
      className={classNames('list-group-item border-bottom d-md-flex justify-content-md-between', className)}
      data-e2e={e2e}
    >
      <span className="text-secondary text-truncate me-2" data-e2e={`${e2e}-label`}>
        {formatMessage({ id: labelKey, defaultMessage: defaultLabelMessage })}
      </span>
      <div className="text-truncate">
        <GenericErrorBoundary context={{ labelKey: labelKey }}>{children}</GenericErrorBoundary>
      </div>
    </li>
  );
};
